import { IResult } from "./types";

const highLightExcutor = (result: IResult) => {
  if (!result) return;
  const { RevisionInformation, ProcedureFiles } = result;
  let dynaimiceStyle = ``;
  // RevisionInformation part
  const keys = Object.keys(RevisionInformation);
  keys.forEach((key) => {
    if (!RevisionInformation[key as keyof typeof RevisionInformation]) return;
    if (key === "RevisionAttachment") {
      const element = document.querySelector(`[data-highlight-id='RevisionAttachment']`);
      if (!element) return;
      element.classList.add("highlighted-element-RevisionAttachment");
    } else if (key === "RequestDate") {
      const element = document.querySelector(`[data-highlight-id='${key}']`);
      if (!element) return;
      element.classList.add("highlighted-element-RequestDate");
    } else {
      const element = document.querySelector(`[data-highlight-id='${key}']`);
      if (!element) return;
      element.classList.add("highlighted-element-default");
    }
  });

  // ProcedureFiles part
  const procedureFileKeys = Object.keys(ProcedureFiles);
  procedureFileKeys.forEach((key) => {
    if (!ProcedureFiles[key as keyof typeof ProcedureFiles]) return;
    if (key === "ClientServerPath") {
      const element = document.querySelector(`[data-highlight-id='${key}Type1']`);
      if (element) {
        element.classList.add("highlighted-element-default");
      }

      const element2 = document.querySelector(`[data-highlight-id='${key}Type2']`);
      if (element2) {
        element2.classList.add("highlighted-element-default-2");
      }
    } else if (key === "SavedInStatus") {
      const element = document.querySelector(`[data-highlight-id='${key}']`);
      if (!element) return;
      element.classList.add("highlighted-element-SavedInStatus");
    } else if (key === "ServerPathStatus") {
      const element = document.querySelector(`[data-highlight-id='${key}']`);
      if (!element) return;
      element.classList.add("highlighted-element-SavedInStatus");
    } else if (key === "ProcedureSavedIn") {
      const element = document.querySelector(`[data-highlight-id='${key}Type1']`);
      if (element) {
        element.classList.add("highlighted-element-default");
      }
      const element2 = document.querySelector(`[data-highlight-id='${key}Type2']`);
      if (element2) {
        element2.classList.add("highlighted-element-default-2");
      }
    } else if (key === "LevelCChange") {
      const element = document.querySelector(`[data-highlight-id='LevelCChange']`);
      if (!element) return;
      element.classList.add("highlighted-element-LevelCChange");
    } else if (key === "FileNameList") {
      const fileList = ProcedureFiles[key as keyof typeof ProcedureFiles] as string[];
      fileList.forEach((fileKey: string) => {
        const fileElement = document.querySelector(`[data-highlight-id='${fileKey}']`);
        if (!fileElement) return;
        dynaimiceStyle += `
              [data-highlight-id^="${fileKey}"] td {
                background-color: #3D83FF24 !important;
              }
          `;
      });
    }
  });

  let styleElement = document.getElementById("highlight-style-global");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.id = "highlight-style-global";
    document.head.appendChild(styleElement);
  }

  styleElement.textContent = `
      .highlighted-element-default {
        position: relative;
        z-index: 1;
      }
      .highlighted-element-default::before {
        content: "";
        position: absolute;
        top: -0.375rem;
        right: -0.375rem;
        bottom: -0.375rem;
        left: -0.375rem;
        background: #3d83ff24;
        z-index: -1;
        pointer-events: none;
      }
      .highlighted-element-default-2 {
        position: relative;
        z-index: 1;
      }
      .highlighted-element-default-2::before {
        content: "";
        position: absolute;
        top: 0.375rem;
        right: 0.375rem;
        bottom: 0.375rem;
        left: 0.375rem;
        background: #3d83ff24;
        z-index: -1;
        pointer-events: none;
      }

      .highlighted-element-RequestDate {
        position: relative;
        z-index: 1;
      }
      .highlighted-element-RequestDate::before {
        content: "";
        position: absolute;
        top: -0.375rem;
        right: 18.875rem;
        bottom: -0.375rem;
        left: -0.375rem;
        background: #3d83ff24;
        z-index: -1;
        pointer-events: none;
      }

      .highlighted-element-SavedInStatus {
        position: relative;
        z-index: 1;
      }
      .highlighted-element-SavedInStatus::before {
        content: "";
        position: absolute;
        top: -1.625rem;
        right: -0.75rem;
        bottom: -1.625rem;
        left: -0.75rem;
        background: #3d83ff24;
        z-index: -1;
        pointer-events: none;
      }

      .highlighted-element-RevisionAttachment {
        position: relative;
        z-index: 1;
      }
      .highlighted-element-RevisionAttachment::before {
        content: "";
        position: absolute;
        top: -0.375rem;
        right: -0.375rem;
        bottom: -0.375rem;
        left: -6.625rem;
        background: #3d83ff24;
        z-index: -1;
        pointer-events: none;
      }

      .highlighted-element-LevelCChange {
        position: relative;
        z-index: 1;
      }
      .highlighted-element-LevelCChange::before {
        content: "";
        position: absolute;
        top: -0.375rem;
        right: -2.625rem;
        bottom: -0.375rem;
        left: -0.375rem;
        background: #3d83ff24;
        z-index: -1;
        pointer-events: none;
      }

      ${dynaimiceStyle}
    `;
  document.head.appendChild(styleElement);
};

export default highLightExcutor;
